import React from 'react';
import { Gift as GiftModel } from 'acscp/store';
import style from './gift.module.scss';
import { BasketGiftQuantityModifier } from 'acscp/components/loyalty/basketGiftQuantityModifier';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { ConstrainedImage } from 'acscp/components/common/constrainedImage';
import { ButtonLaunchingModal } from 'acscp/components/common/buttonLaunchingModal';
import { GiftDetailsPage } from 'acscp/components/loyalty/giftDetailsPage';

interface GiftOwnProps {
    gift: GiftModel;
    isPlaceholder: boolean;
}

export class Gift extends React.Component<GiftOwnProps, {}> {
    render(): JSX.Element | null {
        const { gift } = this.props;
        const imageUrl = gift.image ? gift.image.thumbnailUrl : undefined;

        return (
            <div className={classNames(style.Gift, { [style.Placeholder]: this.props.isPlaceholder})}>
                <div className={style.Image}>
                    <ConstrainedImage src={imageUrl} ratio={1} alignBottom={true} />
                </div>
                <p className={style.Title}>{gift.name}</p>
                <p className={style.Price}>
                    <FormattedMessage
                        id={'components.gifts.gift.price'}
                        defaultMessage={`Points: {price, number}`}
                        values={{price: gift.price}}
                    />
                </p>
                <p className={style.Description}>{gift.description}</p>

                <div className={style.ButtonsContainer}>
                    <ButtonLaunchingModal
                        buttonContent={
                            <FormattedMessage
                                id={'components.gifts.loyaltyPage.viewGiftDescription'}
                                defaultMessage={'VIEW DESCRIPTION'}
                            />}
                        buttonClassName={style.ViewDescription}
                        overlayClassName={style.GiftDescriptionModalOverlay}
                        modalHeaderContent={
                            <FormattedMessage
                                id={'components.gifts.loyaltyPage.viewGiftDescriptionModalHeader'}
                                defaultMessage={'Gift Details'}
                            />
                        }
                    >
                        <GiftDetailsPage gift={gift}/>
                    </ButtonLaunchingModal>
                    <BasketGiftQuantityModifier gift={gift} counterOnly={false} />
                </div>
            </div>
        );
    }
}
